module.exports = __webpack_public_path__ + "static/media/games4.f5551906.png";